<template>
    <div >
        <div class="border-top border-bottom">
            <div class="btn-group flex-wrap w-100 py-3 px-3 bg-light">
                <!-- search -->
                <div class="toobar-search pr-2">
                    <div class="input-group bg-white">
                        <input type="text" @keydown.enter.prevent="search()" v-model="paramsQuery.search" name="search"
                            :placeholder="$t('Tracking No. Search')" style="min-width: 225px"
                            class="border-right-0 form-control pl-2 px-0" />
                        <span class="input-group-append">
                            <button class="btn btn-outline-normal border-left-0 btn-search" type="button"
                                @click="search">
                                <i class="far fa-search"></i>
                            </button>
                        </span>
                    </div>
                </div>

                <!-- perpage -->
                <div class="dataTables_length ml-auto mb-0">
                    <PerPage @per-page="setPerPage" />
                </div>
            </div>
        </div>
        <div :class="['table-responsive mt-0 data-nowrap table-order']" id="table-order">
            <div class="vuetable-wrapper datatable-scroll">
                <vuetable :class="[loadingTable]" ref="vuetable" :no-data-template="$t('No Data Available')"
                    :fields="table.fields" data-path="data" pagination-path="" :api-mode="false"
                    :data-manager="dataManager" @vuetable:loaded="vuetableLoaded" @vuetable:loading="vuetableLoading"
                    @vuetable:pagination-data="onPaginationData">
                    <template slot="tracking_number" slot-scope="props">
                            <img v-if="!integrationTypeResult[props.rowIndex]" class="rounded pointer" width="25" height="25" :src="$storeIndex.getImageGobalAssets('')" alt="">

                            <img v-else :src="integrationTypeResult[props.rowIndex]" width="20" height="20">

                            {{props.rowData.tracking_number}}
                    </template>

                    <template slot="name" slot-scope="props">
                        <div class="d-flex align-items-center">
                            <span class="mr-2">
                                <img class="pointer image_box_variant" :src="props.rowData.product_media_first
                                            ? props.rowData.product_media_first.media.image_url
                                            : $storeIndex.getImageGobalAssets('')
                                        " />
                            </span>
                            <span>
                                <div class="media-title">
                                    {{ props.rowData.name }}
                                </div>
                                <div class="text-grey-300 font-size-xs" v-if="props.rowData.sku">
                                    {{ $t("SKU") }} : {{ props.rowData.sku }}
                                </div>
                            </span>
                        </div>
                    </template>
                </vuetable>
            </div>
            <div class="datatable-footer pl-3 pr-3">
                <vuetable-pagination-info class="dataTables_info" ref="paginationInfo"
                    :no-data-template="$t('No relevant data')"
                    :info-template="$t('Displaying {from} to {to} of {total} items')"></vuetable-pagination-info>
                <div class="dataTables_paginate paging_simple_numbers mb-0">
                    <vuetable-pagination ref="pagination" pagination-path="pagination"
                        @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Api from "@/services/endpoint/tenant.service";
    import DateRangePicker from "vue2-daterange-picker";
    import PerPage from "../PerPage.vue";
    import Select2 from "v-select2-component";
    import Vuetable from "vuetable-2";
    import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
    import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo";
    import codFieldsWaiting from "../assets/js/cod_fields_detail.js";
    import {
        showTextPicker,
    } from "../assets/directives/Vuetable.js";
    import moment from "moment";
    import {
        convertTimezone
    } from "@/common/tenancy/convertTimezone";
    import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
    export default {
        name: "detailteble",
        components: {
            DateRangePicker,
            PerPage,
            Select2,
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo,
            PlaceholderContent
        },
        data: function () {
            return {
                paramsQuery: {
                    search: null,
                    per_page: 10,
                    current_page: 1,
                    sort: '',
                    page: 1
                },
                loadingTable: null,
                table: {
                    fields: codFieldsWaiting,
                },
                integrationType:[],
                integrationTypeResult:[]
            }
        },
        methods: {
            dataManager(sortOrder, pagination) {
                if (sortOrder.length > 0) {
                    this.paramsQuery.sort = sortOrder.map((item) => `${item.sortField}|${item.direction}`).join(',')
                }
                this.setParams();
            },
            onPaginationData(tablePagination) {
                this.$refs.paginationInfo.setPaginationData(tablePagination);
                this.$refs.pagination.setPaginationData(tablePagination);
            },
            onChangePage(page) {
                this.$refs.vuetable.changePage(page);
            },
            onInitialized(fields) {
                console.log('fields', fields);
                this.vuetableFields = fields.filter(field => field.togglable);
            },
            search() {
                this.setParams();
            },
            setPerPage(perPage) {
                this.paramsQuery.current_page = 1;
                this.$refs.vuetable.currentPage = 1;
                this.paramsQuery.per_page = perPage;
                this.setParams();
            },
            vuetableLoaded() {
                this.$parent.onload = false;
            },
            vuetableLoading() {
            },
            cancelDateRange() {
                this.paramsQuery.dateRange.startDate = null;
                this.paramsQuery.dateRange.endDate = null;
                $(".daterangepicker").remove();
                this.setParams();
            },
            applyDatePicker(dateRange) {
                this.paramsQuery.dateRange = dateRange;
                this.setParams();
            },
            async setParams() {
                try {
                    this.loadingTable = "loading";

                    if (this.paramsQuery.dateRange) {
                        if (this.paramsQuery.dateRange.startDate && this.paramsQuery.dateRange.endDate) {
                            let startDate = this.paramsQuery.dateRange.startDate ? moment(this.paramsQuery.dateRange
                                .startDate).format('YYYY-MM-DD') : null;
                            let endDate = this.paramsQuery.dateRange.endDate ? moment(this.paramsQuery.dateRange
                                .endDate).format('YYYY-MM-DD') : null;

                            var afterStartDate = startDate + ' 00:00:00';
                            var afterEndDate = endDate + ' 23:59:59';

                            this.paramsQuery.dateRange.startDate = convertTimezone.localToUtc(afterStartDate);
                            this.paramsQuery.dateRange.endDate = convertTimezone.localToUtc(afterEndDate);
                        }
                    }

                    this.paramsQuery.page = this.$refs.vuetable.currentPage;
                    let queryString = "";
                    let id = this.$route.params.id;
                    const codAccountId = this.$route.params.cod_account_id; 
                    if (this.paramsQuery) {
                        queryString += "?" + $.param(this.paramsQuery);
                    }
                    // let data = this.$storeIndex.mutations.vueTableFormatJson(
                        let data = await Api.Report.getCodReconcileView(queryString, id, codAccountId)
                    // );

                    const integrationType = await Api.IntegrationType.getIntegrationType();
                    this.integrationType = integrationType.data;

                    let vm = this;
                    var result=[];

                    if(data.data.length != 0){
                        data.data.data.forEach(function(type){

                            var logo = vm.integrationType.find(x => x.code == type.code).logo;
                            result.push(logo);
                        });

                        this.integrationTypeResult = result;
                    }

                    this.$refs.vuetable.setData(data.data);
                    this.loadingTable = "";
                    this.$parent.hasPermission = false;
                    this.$parent.onload = false;
                }
                catch(error) {
                    if (error.response.status == 403) {
                        this.$parent.hasPermission = true;
                        this.$parent.onload = false;
                    } else {
                        this.$router.push({name: "t.a.home"});
                        console.log(error.response, 'error');
                    }
                }
            },
        },
        async mounted() {
            // this.onload = true;
        },
    };

</script>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/DetailTable.vue